import React, { useEffect, useState } from "react";
import {
  Box, Typography, Grid, Tabs, Tab, FormControlLabel, Button, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Divider, TextField, Radio, RadioGroup, FormControl, FormLabel, Snackbar
} from "@mui/material";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector, useDispatch } from "react-redux";
import ProductInfo from "./ProductInfo";
import { updateProductObj } from 'store/slice/PharmaSlice';
import { updateRMstatusAPI } from 'api/OmsOrdermgmtWebServices';
import { setCompleteTaskButtonEnabled } from "store/slice/AppSlice";
import { setTaskApiResponse, setTaskApiResponseError } from "store/slice/AppSlice";
import { updateProductInfo } from "components/product/ProductAPI";
import MuiAlert from "@mui/material/Alert";
import CommentMgmt from "./comment/CommentMgmt";

export default function TaskSpaceRM() {
  const dispatch = useDispatch();
  const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
  const { selectedTaskObj } = useSelector((state) => state.appslice.wkflow);
  const {taskApiResponse} = useSelector((state) => state.appslice.wkflow);

  // RM Ordered Date edit state
  const [editDate, setEditDate] = useState(false);
  const [rmOrderedDate, setRmOrderedDate] = useState(productObj?.rmorderedon ? productObj.rmorderedon.split('T')[0] : '');

  // RM Received Date edit state
  const [rmIsAvailableSaved, setRmIsAvailableSaved] = useState(false);
  const [taskCompleted, setTaskCompleted] = useState(false);
  const [rmStatus, setRmStatus] = useState(productObj.rmstatus);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (taskApiResponse && taskApiResponse.success) {
      setTaskCompleted(true);
    } else 
      setTaskCompleted(false);
  },[taskApiResponse]);
  useEffect(() => {
    
  },[rmIsAvailableSaved]);
  useEffect(() => {
    dispatch(setTaskApiResponse(null));
    dispatch(setTaskApiResponseError(''));

    setRmStatus(productObj.rmstatus);
    setRmOrderedDate(productObj?.rmorderedon ? productObj.rmorderedon.split('T')[0] : '');
    if (productObj.rmstatus ==='') {
      dispatch(setCompleteTaskButtonEnabled(false));
    } else {
      if (productObj.rmstatus=== 'AVAILABLE' || (productObj.rmstatus === 'ORDERED' && productObj.rmreceivedon !== undefined)) {
      dispatch(setCompleteTaskButtonEnabled(true));
    }
    }
    
  
  }, [productObj]);

  const updateRMstatus = (statusValue) => {
    if (productObj){
      updateProductInfo(
        productObj.id,{
          rmstatus: statusValue
        },
        (response) => {
          dispatch(updateProductObj(response));
        },
        (error) => {
          console.error("Error updating RM status", error);
          setSnackbarMsg("Error updating RM status");
          setSnackbarOpen(true);
        }   
      );   
    }
       
  }

  const handleSaveDate = () => {
    updateRMstatusAPI(
      {
        productId: productObj.id,
        rmOrderedOn: rmOrderedDate
      },
      (response) => {
        setEditDate(false);
        setRmIsAvailableSaved(true);
        dispatch(updateProductObj(response.productInfo));
        dispatch(setCompleteTaskButtonEnabled(true));
      },
      (error) => {
        setSnackbarMsg("Error updating RM ordered date");
        setSnackbarOpen(true);
      }
    );
  };

  
  return (
    <Grid container direction="row" sx={{ width: '100%' }}>
      <Grid item lg={12} md={12} sm={12} xs={12} >
        <Grid container sx={{ width: '100%' }}>
          <Grid item lg={4} md={4} sm={4} xs={12}>
            <Box sx={{ borderRadius: 2, minHeight: '75vh', p: 0 }}>
                                <Tabs
                                  value={tabIndex}
                                  onChange={(_, v) => setTabIndex(v)}
                                  variant="fullWidth"
                                  sx={{ borderBottom: 1, borderColor: 'divider' }}
                                >
                                  <Tab label="Product Info" />
                                  <Tab label="Comments" />
                                </Tabs>
                                <Box sx={{}}>
                                  {tabIndex === 0 && (
                                    <ProductInfo maxHeight="70vh" />
                                  )}
                                  {tabIndex === 1 && (
                                    <Box sx={{ p: 2, minHeight: '70vh' }}>
                                      <Box sx={{ backgroundColor: 'white', borderRadius: 2, p: 1 }}>
                                        <CommentMgmt maxHeight="60vh" status={1} />
                                      </Box>
                                    </Box>
                                  )}
                                </Box>
                              </Box>
          </Grid>
          <Grid item lg={8} md={4} sm={4} xs={4} sx={{ pt: 2 }}>
            <Grid container direction="column" sx={{ width: '100%', backgroundColor: 'white', borderRadius: 2, p: 2 }}>
              <Grid item lg={12} md={12} sm={12} xs={12} sx={{ mt: 2, mb:1, backgroundColor: 'white', borderRadius: 2, }}>
                <FormControl component="fieldset" sx={{ }}>
                <FormLabel component="legend" sx={{ fontWeight: 600, color: 'primary.main' }}>RM Status</FormLabel>
                <RadioGroup
                  row
                  value={rmStatus}
                  onChange={e => updateRMstatus(e.target.value)}
                  disabled={taskCompleted}
                >
                  <FormControlLabel value="AVAILABLE" control={<Radio />} label="Available" disabled={taskCompleted}/>
                  <FormControlLabel value="ORDERED" control={<Radio />} label="Ordered" disabled={taskCompleted}/>
                </RadioGroup>
              </FormControl>
              </Grid>
              {rmStatus === 'ORDERED' && (
                <Grid item lg={12} md={12} sm={12} xs={12} sx={{borderTop: '1px solid #ccc'}}>
                  <Box sx={{ backgroundColor: 'white', borderRadius: 2, mt:2}}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'primary.main' }}>
                      RM Ordered Date
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center',  justifyContent: 'space-between' }}>
                      {editDate ? (
                        <>
                          <input
                            type="date"
                            value={rmOrderedDate}
                            onChange={e => setRmOrderedDate(e.target.value)}
                            style={{ width: '90%', fontSize: 16, padding: 6, borderRadius: 4, border: '1px solid #ccc' }}
                            max={new Date().toISOString().split('T')[0]} // do not allow future date
                          />
                          <Button
                            variant="contained"
                            size="small"
                            sx={{ ml: 2 }}
                            onClick={handleSaveDate}
                          >
                            Save
                          </Button>
                        </>
                      ) : (
                        <>
                          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                            {productObj?.rmorderedon ? productObj.rmorderedon.split('T')[0] : 'N/A'}
                          </Typography>
                          { !taskCompleted && (
                            <IconButton
                              size="small"
                              sx={{ ml: 1 }}
                              onClick={() => setEditDate(true)}
                            >
                              <EditOutlinedIcon fontSize="small" />
                            </IconButton>
                          )}
                        </>
                      )}
                    </Box>
                  </Box>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MuiAlert onClose={() => setSnackbarOpen(false)} severity="error" sx={{ width: '100%' }}>
          {snackbarMsg}
        </MuiAlert>
      </Snackbar>
    </Grid>
  );
}